import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { Errors, CashpaymentService } from '../../../../../core';
import { FileService } from '../../../../../core';
import { DataTableColumn } from '../../../../../shared/ui/data-table/data-table.component';

@Component({
  selector: 'app-partner-breakdown',
  templateUrl: './partner-breakdown.component.html',
  styleUrls: ['./partner-breakdown.component.scss']
})
export class PartnerBreakdownComponent implements OnInit {
  @Input() selectedPartnerData: any;
  @Input() userProfile: any;
  @Output() close = new EventEmitter<void>();

  errors: Errors = { errors: {} };
  firstName: any = '';
  lastName = '';
  breakdownPageNo: number = 1;
  breakdownSize: number = 5;
  partnerBreakdownGridData: any = [];
  isBreakdownDataLoading: boolean = false;
  breakdownTableColumns: DataTableColumn[] = [
    { field: 'firstName', header: 'First Name' },
    { field: 'lastName', header: 'Last Name' },
    { field: 'amount', header: 'Amount' }
  ];

  constructor(
    private cashPaymentService: CashpaymentService,
    private fileService: FileService
  ) {}

  ngOnInit(): void {
    this.getpartnerBreakdownGridData();
  }

  getpartnerBreakdownGridData(pageIndex?: any, pageEvent?: any): void {
    let req = '';

    if (pageIndex === 'reset') {
      this.breakdownPageNo = 1;
      this.breakdownSize = 5;
    }
    if (pageEvent) {
      this.breakdownPageNo = pageEvent;
    }

    if (this.firstName) {
      req = req + '&firstName=' + this.firstName;
    }
    if (this.lastName) {
      req = req + '&lastName=' + this.lastName;
    }

    req = 'companyId=' + this.userProfile.company.id + '&cashPaymentId=' +
      this.selectedPartnerData.cashPaymentId + req + '&page=' +
      (this.breakdownPageNo - 1) + '&size=' + this.breakdownSize;

    this.isBreakdownDataLoading = true;
    this.cashPaymentService.getPartnerLeaderBreakdownData(req).subscribe(
      (data: any) => {
        this.partnerBreakdownGridData = data;
        this.isBreakdownDataLoading = false;
      },
      (err: any) => {
        this.errors = err;
        this.isBreakdownDataLoading = false;
      }
    );
  }

  onClose(): void {
    this.close.emit();
  }

  onReset(): void {
    this.firstName = '';
    this.lastName = '';
    this.breakdownPageNo = 1;
    this.getpartnerBreakdownGridData('reset');
  }

  partnerLevelBreakdownExportData(cashPaymentId?: any): void {
    const id = cashPaymentId || this.selectedPartnerData.cashPaymentId;
    const url = this.cashPaymentService.buildPartnerLevelBreakdownExportUrl(this.userProfile.company.id, id);
    const fileName = `Payment_File.xlsx`;
    this.fileService.excelDownloadFile(url, fileName, true);
  }

  partnerLevelExportDetailedBreakdown(): void {
    const url = this.cashPaymentService.buildPartnerLevelDetailedBreakdownUrl(
      this.userProfile.company.id,
      this.selectedPartnerData.cashPaymentId
    );
    const fileName = `Payment_File.xlsx`;
    this.fileService.excelDownloadFile(url, fileName, true);
  }

  getBreakdownTableData(): any[] {
    if (!this.partnerBreakdownGridData || !this.partnerBreakdownGridData.content) {
      return [];
    }
    return this.partnerBreakdownGridData.content.map((item: any) => ({
      ...item,
      amount: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }).format(item.amount || 0)
    }));
  }
}
